module.exports = __webpack_public_path__ + "img/diesel-homepage.34ee93a6.png";